import { render, staticRenderFns } from "./NewPromotionProducts.vue?vue&type=template&id=62ebe1ea&"
import script from "./NewPromotionProducts.vue?vue&type=script&lang=js&"
export * from "./NewPromotionProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/NewPromotionProducts.vue
// module id = null
// module chunks = 